import { supabase } from './supabase';

// Registra un evento de auditoría a nivel de aplicación (no bloqueante).
// operacion: p.ej. 'IMPRESION_ETIQUETAS', 'CONSULTA_BUSQUEDA', 'ONBOARDING_PASO_2'.
export async function registrarAuditoria(tid, operacion, detalle = {}) {
  if (!tid || !navigator.onLine) return;
  try {
    await supabase.rpc('registrar_auditoria', { p_tenant: tid, p_operacion: operacion, p_detalle: detalle });
  } catch (_) { /* nunca bloquea el flujo del usuario */ }
}

// EMBUDO de activación (H): 5 pasos clave. La IDEMPOTENCIA vive en la BASE (registrar_auditoria
// devuelve {ok:true, idempotente:true} sin duplicar), así que aquí solo disparamos el evento y punto.
// NO cachear en cliente: contaría dos veces al mismo tenant si entra desde dos dispositivos.
export async function registrarEmbudo(tid, paso, detalle = {}) {
  if (!tid || !navigator.onLine || !paso) return;
  try {
    await supabase.rpc('registrar_auditoria', { p_tenant: tid, p_operacion: `EMBUDO_${paso}`, p_detalle: detalle });
  } catch (_) { /* nunca bloquea el flujo del usuario */ }
}
